import { pathnameAtom } from "./common";
import { keyDidAtom, refreshLocAtom, toggleCityAtom } from "./app";
import dailyApi from "@/api/dailyApi";
import { homeAtom } from "./home";
import { refreshIdAtom } from "./refreshId";
import {
  assignKeyDidToParams,
  assignResolvedKeyIdForSubPageQueries,
  applyDkWeatherDailyHomepageCount,
  clearKeyAidBidCidDidWhenRefreshingLoc,
  persistSubpageApiInfoAndHeader,
} from "./utils/weatherQueryShared";

const dayListAtom = atom<any>([]);
const queryDailyAtom = atom(null, async (get, set, newParams: any) => {
  try {
    assignResolvedKeyIdForSubPageQueries(get, newParams, homeAtom);
    const refreshloc = get(refreshLocAtom);
    const toggleCity = get(toggleCityAtom);
    const pathname = get(pathnameAtom);
    clearKeyAidBidCidDidWhenRefreshingLoc(newParams, !!refreshloc || !!toggleCity);
    assignKeyDidToParams(newParams, get(keyDidAtom));
    applyDkWeatherDailyHomepageCount(newParams, pathname);

    const resData = await dailyApi.query(newParams);
    const formattedDayList: any[] =
      resData?.data?.dayList?.map((item: any) => ({
        ...item,
        isExpand: false,
      })) || [];

    persistSubpageApiInfoAndHeader(set, resData?.data?.info);
    set(dayListAtom, formattedDayList);
    set(refreshIdAtom, get(refreshIdAtom) + 1);
    return resData;
  } catch (error) {
    console.error("查询每日数据失败：", error);
    throw error;
  }
});

export { dayListAtom, queryDailyAtom };
